import { useEffect, useMemo } from 'react';

const warnUser = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  e.returnValue = '';
};

export const UNSAVED_WARNING_MESSAGE = 'Are you sure you want to leave this page? Changes you made may not be saved.';

export default function useOnExitPrompt(promptOnExit: boolean) {
  useEffect(() => {
    if (promptOnExit) {
      window.addEventListener('beforeunload', warnUser);
    } else {
      window.removeEventListener('beforeunload', warnUser);
    }
    return () => {
      window.removeEventListener('beforeunload', warnUser);
    };
  }, [promptOnExit]);

  return useMemo(() => {
    return () => {
      if (promptOnExit) {
        // eslint-disable-next-line no-restricted-globals
        return confirm(UNSAVED_WARNING_MESSAGE);
      }
      return true;
    };
  }, [promptOnExit]);
}
